var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4001_4021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 0.000236511H80.4998V80H0.5V0.000236511Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4001_4021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.3556 14.1738C35.6131 23.3075 35.4257 22.7209 33.3467 30.7764H47.6537C45.5746 22.7209 45.3873 23.3075 43.6448 14.1738H37.3556Z",
    fill: "#E1D3CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.1926 9.61657C36.5096 10.8683 36.8729 12.318 37.3551 14.1736H43.6443C44.1264 12.318 44.4897 10.8683 44.8068 9.61657C45.493 6.90736 43.4458 4.27721 40.651 4.27721H40.3485C37.5537 4.27721 35.5062 6.90736 36.1926 9.61657Z",
    fill: "#9E9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.7918 35.7812H31.2075C30.9759 35.7813 30.7502 35.7083 30.5625 35.5726C30.3747 35.437 30.2346 35.2457 30.1618 35.0258L29.2356 32.2227C29.0003 31.5103 29.5307 30.7763 30.2811 30.7763H50.718C51.4683 30.7763 51.9988 31.5103 51.7635 32.2227L50.8371 35.0258C50.7645 35.2456 50.6243 35.437 50.4367 35.5726C50.249 35.7083 50.0233 35.7813 49.7918 35.7812Z",
    fill: "#9E9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.2866 55.6763H24.7138C24.4878 55.6763 24.2673 55.6068 24.0822 55.4772C23.8972 55.3475 23.7565 55.1641 23.6792 54.9517L22.6591 52.1488C22.3978 51.4307 22.9297 50.6713 23.6938 50.6713H57.3065C58.0707 50.6713 58.6024 51.4307 58.341 52.1488L57.3212 54.9517C57.2439 55.1641 57.1032 55.3475 56.9181 55.4771C56.7331 55.6067 56.5126 55.6763 56.2866 55.6763Z",
    fill: "#9E9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.0156 71.1253C32.4875 66.7953 36.1444 63.5152 40.5 63.5152H40.5001C44.8558 63.5152 48.5125 66.7953 48.9843 71.1253L49.8239 78.8281H62.4241L55.2124 55.6765H25.7875L18.5757 78.8281H31.1763L32.0156 71.1253Z",
    fill: "#E1D3CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M45.4844 47.4731C45.2072 44.6856 43.0588 42.5742 40.4999 42.5742C37.941 42.5742 35.7927 44.6856 35.5154 47.4731L35.0223 50.6714H27.6196L31.8563 35.7677H49.1433L53.38 50.6714H45.9774L45.4844 47.4731Z",
    fill: "#E1D3CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M43.6445 14.1738H38.957C40.6995 23.3075 40.8869 22.7208 42.9659 30.7764H47.6534C45.5744 22.7208 45.387 23.3075 43.6445 14.1738Z",
    fill: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.6514 4.27721H40.3487C39.5389 4.27721 38.7925 4.49924 38.1562 4.87892C39.715 5.80955 40.6072 7.69251 40.1197 9.61657C39.8025 10.8683 39.4394 12.318 38.9572 14.1736H43.6447C44.1269 12.318 44.49 10.8683 44.8072 9.61657C45.4934 6.90736 43.4462 4.27721 40.6514 4.27721Z",
    fill: "#766E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M50.7182 30.7763H46.0307C46.7812 30.7763 47.3117 31.5103 47.0762 32.2227L46.15 35.0258C46.0773 35.2456 45.9371 35.437 45.7494 35.5726C45.5617 35.7083 45.3361 35.7813 45.1045 35.7812H49.792C50.0235 35.7813 50.2492 35.7083 50.4369 35.5726C50.6246 35.437 50.7648 35.2456 50.8374 35.0258L51.7637 32.2227C51.9992 31.5103 51.4687 30.7763 50.7182 30.7763Z",
    fill: "#766E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M57.306 50.6711H52.6185C53.3827 50.6711 53.9144 51.4305 53.653 52.1486L52.6332 54.9517C52.5559 55.1641 52.4152 55.3475 52.2301 55.4771C52.045 55.6067 51.8246 55.6762 51.5986 55.6763H56.2861C56.5121 55.6762 56.7325 55.6067 56.9176 55.4771C57.1027 55.3475 57.2434 55.1641 57.3206 54.9517L58.3405 52.1486C58.6019 51.4305 58.0702 50.6711 57.306 50.6711Z",
    fill: "#766E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M55.2124 55.6765H50.5249L57.7364 78.8281H62.4239L55.2124 55.6765Z",
    fill: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M49.1431 35.7677H44.4556L48.6924 50.6714H53.3799L49.1431 35.7677Z",
    fill: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.6058 66.7617C15.6058 70.8263 13.0118 72.4512 9.81196 72.4512C6.61197 72.4512 4.01807 70.8263 4.01807 66.7617C4.01807 62.697 5.68837 53.6915 9.81196 53.6915C13.6224 53.6915 15.6058 62.697 15.6058 66.7617Z",
    fill: "#6FD7A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M77.0507 66.7617C77.0507 70.8263 74.4566 72.4512 71.2568 72.4512C68.0568 72.4512 65.4629 70.8263 65.4629 66.7617C65.4629 62.697 67.1332 53.6915 71.2568 53.6915C75.0672 53.6915 77.0507 62.697 77.0507 66.7617Z",
    fill: "#6FD7A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M9.81178 53.6915C9.31929 53.6915 8.86194 53.8214 8.43804 54.0545C10.3851 56.9284 11.3869 62.3109 11.3869 65.1992C11.3869 69.2638 8.79288 70.8887 5.59305 70.8887C5.54805 70.8887 5.50367 70.8871 5.45898 70.8865C6.52086 71.972 8.07663 72.4512 9.81178 72.4512C13.0116 72.4512 15.6057 70.8263 15.6057 66.7617C15.6057 62.697 13.6222 53.6915 9.81178 53.6915Z",
    fill: "#3EC3A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M71.2566 53.6915C70.7641 53.6915 70.3068 53.8214 69.8829 54.0545C71.8297 56.9284 72.8318 62.3109 72.8318 65.1992C72.8318 69.2638 70.2377 70.8887 67.0379 70.8887C66.9929 70.8887 66.9485 70.8871 66.9038 70.8865C67.9657 71.972 69.5215 72.4512 71.2566 72.4512C74.4564 72.4512 77.0505 70.8263 77.0505 66.7617C77.0505 62.697 75.0671 53.6915 71.2566 53.6915Z",
    fill: "#3EC3A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M47.4786 30.1013C45.5624 22.7465 45.3371 23.0442 43.6447 14.1736H37.3555C35.6676 23.0212 35.439 22.7479 33.5366 30.0438",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M36.1926 9.61657C36.5096 10.8683 36.8729 12.318 37.3551 14.1736H43.6443C44.1264 12.318 44.4897 10.8683 44.8068 9.61657C45.493 6.90736 43.4458 4.27721 40.651 4.27721H40.3485C37.5537 4.27721 35.5062 6.90736 36.1926 9.61657Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M44.1819 30.7763H50.7184C51.4689 30.7763 51.9992 31.5103 51.7639 32.2227L50.8376 35.0258C50.765 35.2457 50.6248 35.437 50.4371 35.5727C50.2494 35.7083 50.0237 35.7813 49.7922 35.7812H31.2079C30.9763 35.7812 30.7506 35.7082 30.5629 35.5726C30.3752 35.437 30.235 35.2456 30.1622 35.0258L29.2361 32.2227C29.0007 31.5103 29.5311 30.7763 30.2815 30.7763H39.4944",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M30.8728 55.6763H24.7136C24.4877 55.6763 24.2672 55.6068 24.0821 55.4771C23.897 55.3475 23.7563 55.1641 23.6791 54.9517L22.6591 52.1488C22.3979 51.4307 22.9296 50.6713 23.6938 50.6713H57.3065C58.0706 50.6713 58.6024 51.4307 58.341 52.1488L57.3212 54.9517C57.2439 55.1641 57.1032 55.3475 56.9181 55.4771C56.733 55.6067 56.5125 55.6763 56.2865 55.6763H35.5603",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M25.5249 56.5194L18.5757 78.8281H31.1763L32.0156 71.1255C32.4875 66.7953 36.1444 63.5154 40.5 63.5154C44.8556 63.5154 48.5125 66.7953 48.9843 71.1255L49.8239 78.8281H62.4241L55.429 56.3712",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M49.3035 36.3311L53.38 50.6714H45.9774L45.4844 47.4731C45.2071 44.6856 43.0586 42.5742 40.4997 42.5742C37.9408 42.5742 35.7926 44.6856 35.5154 47.4731L35.0223 50.6714H27.6196L31.6693 36.426",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M1.67188 78.8281H79.3279",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M15.6058 66.7617C15.6058 70.8263 13.0118 72.4512 9.81196 72.4512C6.61197 72.4512 4.01807 70.8263 4.01807 66.7617C4.01807 62.697 5.68837 53.6915 9.81196 53.6915C13.6224 53.6915 15.6058 62.697 15.6058 66.7617Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M9.81152 72.4512V78.3003",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M77.0507 66.7617C77.0507 70.8263 74.4566 72.4512 71.2568 72.4512C68.0568 72.4512 65.4629 70.8263 65.4629 66.7617C65.4629 62.697 67.1332 53.6915 71.2568 53.6915C75.0672 53.6915 77.0507 62.697 77.0507 66.7617Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M71.2563 72.4512V78.3003",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.79a4d61558ce98c302015e07262789aa.svg";
export { ForwardRef as ReactComponent };